import { cleanDocument } from '~/helpers/documentNumber'
import { removeSpecialCharacters } from '~/helpers/removeSpecialCharacters'
import { IRegisterCompanyForm, IRegisterPersonForm } from '~/schemas/auth/authFormSchemas'
import {
    IRegisterCompanyRequest,
    IRegisterPersonRequest,
    IRegisterResponse,
    RegisterResponseSchema,
} from '~/schemas/auth/authSchemas'
import { api, apiService } from '~/services/core/ApiService'
import { startSessionService } from './SessionService'

const withLoader = { meta: { showLoader: true } }

/*
 * Cadastro de cliente. A API cria o cliente, passa o carrinho anônimo para ele e devolve token e cliente (sem
 * carrinho): a sessão abre na hora. Erros sem aviso padrão: os de campo (ModelState `.Email`, `.MainDocNumber`,
 * `.Password`) vão para o formulário pelo useFormAction, e o resto vira o aviso genérico dele.
 */

// =========================================================================
// SECTION 1: PESSOA FÍSICA
// =========================================================================

/** `POST /customer/create`: CPF e telefone sem máscara; os termos ficam na tela. */
export const registerPersonService = (form: IRegisterPersonForm): Promise<IRegisterResponse> => {
    const payload: IRegisterPersonRequest = {
        email: form.email,
        firstName: form.firstName,
        lastName: form.lastName,
        phone: removeSpecialCharacters(form.phone),
        cpf: form.cpf ? removeSpecialCharacters(form.cpf) : '',
        occupation: form.occupation ?? '',
        password: form.password,
        confirmPassword: form.confirmPassword,
    }
    return apiService(api)
        .post('/customer/create', payload, RegisterResponseSchema, withLoader)
        .onSuccess((session) => startSessionService(session))
        .onError(() => {}, { useDefaultErrorHandler: false })
        .execute()
}

// =========================================================================
// SECTION 2: PESSOA JURÍDICA
// =========================================================================

/** `POST /customer/create-company-customer`: CNPJ (numérico ou alfanumérico) em maiúsculas e telefone sem máscara. */
export const registerCompanyService = (form: IRegisterCompanyForm): Promise<IRegisterResponse> => {
    const payload: IRegisterCompanyRequest = {
        email: form.email,
        corporateName: form.corporateName,
        companyPhone: removeSpecialCharacters(form.companyPhone),
        cnpj: cleanDocument(form.cnpj),
        occupation: form.occupation ?? '',
        inscricaoMunicipal: form.inscricaoMunicipal,
        inscricaoEstadual: form.inscricaoEstadual,
        password: form.password,
        confirmPassword: form.confirmPassword,
    }
    return apiService(api)
        .post('/customer/create-company-customer', payload, RegisterResponseSchema, withLoader)
        .onSuccess((session) => startSessionService(session))
        .onError(() => {}, { useDefaultErrorHandler: false })
        .execute()
}
